import { Star, Trash2 } from"lucide-react";
import { PCG_INDEX } from"@/lib/pcgUtils";
import { getClass } from"@/data/classMeta";

export default function Favorites({ favs, onSelect, onToggle, onClear }) {
 if (favs.length === 0) {
 return (
 <div data-testid="favorites-empty" className="">
 <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-[#15294F] tracking-tight">
 Mes favoris
 </h2>
 <div className="mt-6 p-8 rounded-xl border border-dashed border-slate-300 bg-white text-center">
 <Star size={32} className="mx-auto text-slate-400 mb-3" />
 <p className="text-slate-600">
 Aucun favori pour l'instant. Cliquez sur l'étoile dans une fiche pour la conserver ici.
 </p>
 </div>
 </div>
 );
 }

 return (
 <div data-testid="favorites-view" className="space-y-6">
 <div className="flex flex-wrap items-center justify-between gap-4">
 <div>
 <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-[#15294F] tracking-tight">
 Mes favoris
 </h2>
 <p className="text-slate-600 text-sm mt-1">
 {favs.length} compte{favs.length > 1 ?"s" :""} à réviser.
 </p>
 </div>
 <button
 data-testid="favorites-clear"
 onClick={onClear}
 className="bg-white text-[#15294F] font-semibold py-2.5 px-4 rounded-md border border-keyto shadow-keyto-sm hover:bg-slate-50 transition-all text-sm flex items-center gap-2"
 >
 <Trash2 size={14} /> Tout effacer
 </button>
 </div>

 <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
 {favs.map((num) => {
 const acc = PCG_INDEX[num];
 if (!acc) return null;
 const cls = getClass(acc.classe);
 return (
 <div
 key={num}
 className="bg-white border border-keyto rounded-xl shadow-keyto-sm overflow-hidden flex flex-col"
 style={{ borderTop: `3px solid ${cls.color.primary}` }}
 >
 <div className="p-4 border-b border-keyto bg-slate-50">
 <div className="flex items-baseline justify-between gap-2">
 <span
 className="font-mono font-extrabold text-2xl"
 style={{ color: cls.color.text }}
 >
 {acc.num}
 </span>
 <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">
 Classe {cls.id}
 </span>
 </div>
 </div>
 <div className="p-4 flex-1 flex flex-col">
 <h3 className="font-heading font-extrabold text-[#15294F] text-sm leading-tight mb-3 flex-1">
 {acc.lib}
 </h3>
 <div className="flex gap-2">
 <button
 data-testid={`fav-open-${num}`}
 onClick={() => onSelect(num)}
 className="flex-1 btn-primary-gradient text-white text-xs font-semibold py-2 px-3 rounded-md transition-colors"
 >
 Ouvrir
 </button>
 <button
 data-testid={`fav-remove-${num}`}
 onClick={() => onToggle(num)}
 className="bg-white border border-keyto text-slate-500 hover:text-rose-600 hover:border-rose-300 text-xs font-semibold py-2 px-3 rounded-md transition-colors"
 >
 <Trash2 size={12} />
 </button>
 </div>
 </div>
 </div>
 );
 })}
 </div>
 </div>
 );
}
